import { render, staticRenderFns } from "./CollapseTicketDetails.vue?vue&type=template&id=528e3c01&scoped=true&"
import script from "./CollapseTicketDetails.vue?vue&type=script&lang=js&"
export * from "./CollapseTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTicketDetails.vue?vue&type=style&index=0&id=528e3c01&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e3c01",
  null
  
)

export default component.exports